export default __webpack_public_path__ + "static/337-07ea47603d70a72ea2d9fc221b42ca1f.gif";